<template>
    <div class="visitor">
        <el-card shadow="always" class="item-car">
            <div class="visitor-content">
                <div class="visitor-title">访问人次统计</div>
                <div class="visitor-count">访问总量：<span class="total-style">{{count}}</span>人次</div>
                <div class="search-box">
                    <div class="check-radio">
                        <el-radio-group v-model="queryParam.type" size="small" @change="changeRadio">
                            <el-radio-button :label="1">近7天</el-radio-button>
                            <el-radio-button :label="2">近14天</el-radio-button>
                            <el-radio-button :label="3">近30天</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div class="time-picker">
                        <el-date-picker
                            v-model="date"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            @change="changeDate"
                        >
                        </el-date-picker>
                    </div>
                </div>
                <div id="man" class="item-car-echart" />
            </div>
        </el-card>
    </div>
</template>
<script>
import api from "@/modules/zjrc/api";
import echarts from 'echarts';
import {formatTimeThree} from '@/utils/index'
export default {
    data() {
        return {
            queryParam: {
                type: 1,
                startDate: null,
                endDate: null
            },
            date:[],
            leftList: [],
            bottomList: [],
            list: {},
            count: 0
        }
    },
    mounted() {
        this.loadData()
    },
    methods: {
        changeRadio(val) {
            const vm = this
            vm.queryParam.type = val
            vm.loadData()
        },
        getCount () {
            const vm = this
            api.getVisitorCount().then(res => {
                vm.count = res.data.Data
            })
        },
        changeDate(v) {
            const vm = this
            if (v === null) {
                vm.queryParam.startDate = null
                vm.queryParam.endDate = null
                vm.queryParam.type = 1
            }else {
                vm.queryParam.startDate = formatTimeThree(v[0])
                vm.queryParam.endDate = formatTimeThree(v[1])
                vm.queryParam.type = null
                debugger
            }
            vm.loadData()
        },
        loadData() {
            const vm = this
            vm.getCount()
            api.queryVisitor(this.queryParam).then(res => {
                if (res.data.Code === 0) {
                    vm.list = res.data.Data
                    vm.bottomList = Object.keys(vm.list).reverse()
                    vm.leftList = Object.values(vm.list).reverse()
                    vm.drawColumnar()
                }
            })
        },
        drawColumnar() {
                let vm = this
                // 基于准备好的dom，初始化echarts实例
                let myChart = echarts.init(document.getElementById('man'))
                myChart.setOption({
                    tooltip: {
                        show:true
                    },
                    xAxis: {
                        type: 'category',
                        data: vm.bottomList
                    },
                    yAxis: {
                        min:0,
                        max: vm.checkLength(),
                        type: 'value'
                    },
                    series: [{
                        type: 'line',
                        data: vm.leftList
                    }]
                })
        },
        checkLength() {
            const vm = this
            var numCount = Math.max(...vm.leftList)
            if (numCount < 10) {
                return 10
            }
        } 
    }
}
</script>
<style scoped lang="scss">
    .visitor {
        height: auto;
        overflow: auto;
        .visitor-content {
            height: 88vh;
            overflow: auto;
            .visitor-title {
                font-size: 18px;
                font-weight: bold;
                padding: 5px 0;
            }
            .visitor-count {
                font-size: 14px;
                font-weight: bold;
                padding: 5px;
                .total-style {
                    color: red;
                }
            }
            .search-box {
                display: flex;
                align-items: center;
                padding: 5px;
                .check-radio {
                    margin-right: 20px;
                }
            }
        }
    }
    .item-car-echart{
        width: 100%;
        height: 500px;
    }
    /deep/ .el-date-editor .el-range__icon {
        line-height: 0;
    }
    /deep/ .el-date-editor .el-range-separator {
        line-height: 1.5;
        padding: 0;
    }
    /deep/ .el-date-editor .el-range__close-icon {
        line-height: 1.5;
    }
</style>